/* ============================================================
   LEWD FASHION — "Complete The Lewk" bundle section behavior
   Asset: assets/lf-lewk.js   (merged brief §4.6 hard spec + §4.1 handoff)

   - Reads server-rendered #lf-lewk-data (custom.bundle_json).
   - Hydrates live prices/variants via /products/{handle}.js ONLY.
   - Auto-swaps sold-out complements to alts; collapses dead slots;
     disables sold-out variant options. Fails INVISIBLE.
   - Anchor is item[0], checked by default, variant read live from
     the PDP product form at click time.
   - ADD THE SET -> ONE batched /cart/add.js with _lewk_bundle line
     property -> window.LFCart.refresh(true) (drawer owns the rest).

   §4.7 items (Lewk Meter feel, ticker animation, badge choreography)
   are intentionally a loose first cut — marked TODO(polish).
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('lf-lewk');
  if (!root) return;

  function gateOut() { if (root && root.parentNode) root.parentNode.removeChild(root); }

  var DATA;
  try {
    DATA = JSON.parse(document.getElementById('lf-lewk-data').textContent);
  } catch (e) { return gateOut(); }                       // §4.6 JSON parse fail

  var bundle = DATA && DATA.bundle;
  if (!bundle || !bundle.enabled || !bundle.items || !bundle.items.length) return gateOut();

  var money = (window.LFUtil && typeof window.LFUtil.money === 'function')
    ? window.LFUtil.money
    : function (c) { return '$' + ((Number(c) || 0) / 100).toFixed(2); };

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var ANCHOR_HANDLE = DATA.anchor_handle;

  /* ---------------- helpers ---------------- */
  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('404'); return r.json(); });
  }
  function firstAvailableVariant(p) {
    return (p.variants || []).filter(function (v) { return v.available; })[0] || null;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function cleanTitle(t) { return String(t || '').split('|')[0].trim(); }

  /* the anchor variant is read LIVE from the PDP product form (§4.1.1) */
  function readPdpVariantId() {
    var el = document.querySelector("form[action*='/cart/add'] [name='id']");
    return el && el.value ? el.value : null;
  }
  function anchorVariant(anchorProduct) {
    var id = readPdpVariantId();
    var v = id && (anchorProduct.variants || []).filter(function (x) { return String(x.id) === String(id); })[0];
    return v || firstAvailableVariant(anchorProduct);
  }
  function anchorEchoOptionValues(anchorProduct) {
    var v = anchorVariant(anchorProduct);
    return v ? (v.options || []).map(String) : [];
  }
  /* size echo (§4.6): pick the first available variant whose option values
     intersect the anchor's selected options, else first available. */
  function pickDefaultVariant(prod, echoVals) {
    var avail = (prod.variants || []).filter(function (v) { return v.available; });
    if (!avail.length) return null;
    if (echoVals && echoVals.length) {
      var m = avail.filter(function (v) {
        return (v.options || []).some(function (o) { return echoVals.indexOf(String(o)) !== -1; });
      })[0];
      if (m) return m;
    }
    return avail[0];
  }

  /* ---------------- hydration + auto-swap (§4.6 exact algorithm) ------------- */
  function hydrateComplement(item) {
    // try primary, then alts in stored order; first with an available variant wins
    var chain = [item.handle].concat(item.alts || []);
    var i = 0;
    function tryNext() {
      if (i >= chain.length) return Promise.resolve(null);       // collapse slot
      var h = chain[i++];
      return fetchProduct(h).then(function (p) {
        if (firstAvailableVariant(p)) return { product: p, item: item };
        return tryNext();
      }).catch(tryNext);
    }
    return tryNext();
  }

  function build() {
    return fetchProduct(ANCHOR_HANDLE).then(function (anchorProduct) {
      if (!firstAvailableVariant(anchorProduct)) return gateOut();  // anchor itself dead
      return Promise.all(bundle.items.map(hydrateComplement)).then(function (results) {
        var comps = results.filter(Boolean);
        if (comps.length < 1) return gateOut();                    // <1 complement -> nothing (§4.6)
        render(anchorProduct, comps);
      });
    }).catch(function () { gateOut(); });
  }

  /* ---------------- render ---------------- */
  var rows = [];          // {kind, handle, product, sel:<select|null>, checkbox, priceEl, item}
  var els = {};

  function optionsHtml(prod, defaultVariantId) {
    return (prod.variants || []).map(function (v) {
      var label = (v.title && v.title !== 'Default Title') ? v.title : cleanTitle(prod.title);
      return '<option value="' + v.id + '"' +
        (String(v.id) === String(defaultVariantId) ? ' selected' : '') +
        (v.available ? '' : ' disabled') + '>' +
        esc(label) + (v.available ? '' : ' — sold out') + '</option>';
    }).join('');
  }

  function badgeHtml(item) {
    if (!item.badge) return '';
    var map = {
      'matched': ['matched ✦', ''],
      'senpai-pick': ['senpai ✦', ''],
      'last few': ['last few', ' lf-badge-lastfew']
    };
    var b = map[item.badge] || [item.badge, ''];
    return '<span class="lf-lewk-badge' + b[1] + '">' + esc(b[0]) + '</span>';
  }

  function render(anchorProduct, comps) {
    var rowEl = document.getElementById('lf-lewk-row');
    var echo = anchorEchoOptionValues(anchorProduct);
    var parts = [];

    // ---- anchor row (item[0], checked by default; variant from PDP form) ----
    var av = anchorVariant(anchorProduct);
    parts.push(
      '<div class="lf-lewk-item lf-anchor lf-checked" data-kind="anchor">' +
        '<div class="lf-lewk-thumb-wrap">' +
          '<input type="checkbox" class="lf-lewk-check" checked aria-label="Include this item">' +
          '<img class="lf-lewk-thumb" src="' + esc(anchorProduct.featured_image || '') + '" alt="">' +
        '</div>' +
        '<div class="lf-lewk-name">' + esc(DATA.anchor_title || cleanTitle(anchorProduct.title)) + '</div>' +
        '<div class="lf-lewk-anchor-note">size from ur selection ✦</div>' +
        '<div class="lf-lewk-price" data-anchor-price></div>' +
      '</div>'
    );

    // ---- complement rows ----
    comps.forEach(function (c) {
      var prod = c.product, item = c.item;
      var dv = pickDefaultVariant(prod, echo);
      parts.push('<div class="lf-lewk-plus" aria-hidden="true">+</div>');
      parts.push(
        '<div class="lf-lewk-item lf-checked" data-kind="comp" data-handle="' + esc(prod.handle) + '">' +
          '<div class="lf-lewk-thumb-wrap">' +
            '<input type="checkbox" class="lf-lewk-check" checked aria-label="Include this item">' +
            '<img class="lf-lewk-thumb" src="' + esc(prod.featured_image || '') + '" alt="">' +
            badgeHtml(item) +
          '</div>' +
          '<div class="lf-lewk-name">' + esc(cleanTitle(prod.title)) + '</div>' +
          '<select class="lf-lewk-size" aria-label="Size">' + optionsHtml(prod, dv && dv.id) + '</select>' +
          '<div class="lf-lewk-price"></div>' +
        '</div>'
      );
    });

    rowEl.innerHTML = parts.join('');

    // ---- wire model ----
    rows = [];
    var itemEls = rowEl.querySelectorAll('.lf-lewk-item');
    itemEls.forEach(function (el) {
      var kind = el.getAttribute('data-kind');
      var row = {
        el: el, kind: kind,
        checkbox: el.querySelector('.lf-lewk-check'),
        sel: el.querySelector('.lf-lewk-size'),
        priceEl: el.querySelector('.lf-lewk-price'),
        checked: true
      };
      if (kind === 'anchor') {
        row.product = anchorProduct;
        row.priceEl = el.querySelector('[data-anchor-price]');
      } else {
        row.product = comps.filter(function (c) { return c.product.handle === el.getAttribute('data-handle'); })[0].product;
      }
      row.checkbox.addEventListener('change', function () {
        row.checked = row.checkbox.checked;
        el.classList.toggle('lf-checked', row.checked);
        recompute(true);
      });
      if (row.sel) row.sel.addEventListener('change', function () { recompute(false); });
      rows.push(row);
    });

    els.total = document.getElementById('lf-lewk-total');
    els.compare = document.getElementById('lf-lewk-compare');
    els.savings = document.getElementById('lf-lewk-savings');
    els.cta = document.getElementById('lf-lewk-cta');
    els.err = document.getElementById('lf-lewk-err');
    els.fill = document.getElementById('lf-lewk-fill');
    els.meterLabel = document.getElementById('lf-lewk-meter-label');
    els.meter = root.querySelector('.lf-lewk-meter');
    els.stamp = document.getElementById('lf-lewk-stamp');
    els.confetti = document.getElementById('lf-lewk-confetti');

    els.cta.addEventListener('click', addTheSet);

    // keep anchor price in sync with the PDP variant selector (§4.1)
    var pdpForm = document.querySelector("form[action*='/cart/add']");
    if (pdpForm) pdpForm.addEventListener('change', function () { recompute(false); });

    recompute(false);
  }

  function currentVariant(row) {
    if (row.kind === 'anchor') return anchorVariant(row.product);
    var id = row.sel ? row.sel.value : null;
    return (row.product.variants || []).filter(function (v) { return String(v.id) === String(id); })[0]
      || firstAvailableVariant(row.product);
  }

  /* ---------------- state machine (§4.6) ---------------- */
  var prevFull = false;

  function recompute(fromToggle) {
    var total = 0, compareTotal = 0, count = 0;
    rows.forEach(function (row) {
      if (row.kind === 'anchor') {
        var av = anchorVariant(row.product);
        if (row.priceEl && av) row.priceEl.textContent = money(av.price);
      } else {
        var v = currentVariant(row);
        if (row.priceEl && v) {
          var was = (v.compare_at_price && v.compare_at_price > v.price)
            ? '<span class="lf-lewk-was">' + money(v.compare_at_price) + '</span>' : '';
          row.priceEl.innerHTML = money(v.price) + was;
        }
      }
      if (!row.checked) return;
      var cv = currentVariant(row);
      if (!cv) return;
      count++;
      total += cv.price;
      compareTotal += (cv.compare_at_price && cv.compare_at_price > cv.price) ? cv.compare_at_price : cv.price;
    });

    els.total.textContent = money(total);

    // savings = struck compare-at only (§4.6 — do NOT fold checkout % in)
    var savings = compareTotal - total;
    if (savings > 0) {
      els.compare.textContent = money(compareTotal);
      els.compare.hidden = false;
      els.savings.textContent = 'save ' + money(savings);
      els.savings.hidden = false;
      if (fromToggle) {                        // TODO(polish): real loss-frame flash on uncheck
        els.savings.classList.remove('lf-loss'); void els.savings.offsetWidth;
        els.savings.classList.add('lf-loss');
      }
    } else {
      els.compare.hidden = true;
      els.savings.hidden = true;
    }

    // CTA enabled only at >=2 checked (§4.6); label always "add the set"
    els.cta.disabled = count < 2;

    // Lewk Meter (§4.7 polish-target, functional cut)
    var pct = rows.length ? Math.round((count / rows.length) * 100) : 0;
    els.fill.style.width = pct + '%';
    var full = count === rows.length && rows.length >= 2;
    els.meter.classList.toggle('lf-full', full);
    els.meterLabel.textContent = full ? 'full lewk unlocked ✦'
      : (count >= 2 ? 'almost the full fit' : 'the start of something');
    if (full && !prevFull) celebrate();
    prevFull = full;
  }

  /* ---------------- ADD THE SET (§4.1 handoff) ---------------- */
  var busy = false;

  function showError(msg) {
    els.err.textContent = msg;
    els.err.hidden = false;
  }
  function clearError() { els.err.hidden = true; els.err.textContent = ''; }

  function addTheSet() {
    if (busy) return;
    var checked = rows.filter(function (r) { return r.checked; });
    if (checked.length < 2) return;           // §4.1.2 minimum 2

    var items = [];
    for (var i = 0; i < checked.length; i++) {
      var v = currentVariant(checked[i]);     // anchor variant re-read live here
      if (!v) { showError("couldn't read a size — check ur selection ♡"); return; }
      items.push({ id: Number(v.id), quantity: 1, properties: { _lewk_bundle: ANCHOR_HANDLE } });
    }

    busy = true; clearError();
    els.cta.classList.add('lf-busy');
    els.cta.textContent = 'adding…';

    // ONE batched call, atomic (§4.1.3/.5); button is NOT in an add form -> no double-add
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, body: j }; });
    }).then(function (res) {
      busy = false;
      els.cta.classList.remove('lf-busy');
      els.cta.textContent = 'add the set';
      if (!res.ok) throw res.body;
      // §4.1.4 — do NOT roll our own drawer
      if (window.LFCart && typeof window.LFCart.refresh === 'function') {
        window.LFCart.refresh(true);
        if (typeof window.LFCart.toast === 'function') window.LFCart.toast('full lewk added ✦');
      } else {
        window.location.href = '/cart';        // graceful fallback if drawer JS absent
      }
    }).catch(function () {
      // §4.1.5 — cart untouched (add.js atomic), inline error, do NOT open drawer.
      busy = false;
      els.cta.classList.remove('lf-busy');
      els.cta.textContent = 'add the set';
      showError("couldn't add that — try again ♡");
      // a variant may have sold out between hydrate + click: silently re-hydrate,
      // then let the shopper retry (§4.1.5 / §4.6 auto-swap)
      build();
    });
  }

  /* ---------------- celebration (reuse shared keyframes, §1.2/§4.7) ---------------- */
  function celebrate() {
    if (reduceMotion) return;
    els.stamp.classList.remove('lf-on'); void els.stamp.offsetWidth;
    els.stamp.classList.add('lf-on');
    setTimeout(function () { els.stamp.classList.remove('lf-on'); }, 1000);
    var glyphs = ['✦', '♡', '★', '✧', '♥'];
    var colors = ['#ffd6e0', '#ff97ad', '#e8457a', '#c93460'];
    for (var i = 0; i < 20; i++) {
      var c = document.createElement('span');
      c.className = 'lf-lewk-confetto';
      c.textContent = glyphs[i % glyphs.length];
      c.style.left = Math.random() * 100 + '%';
      c.style.color = colors[i % colors.length];
      c.style.fontSize = (11 + Math.random() * 12) + 'px';
      c.style.animationDuration = (1.2 + Math.random() * 1.2) + 's';
      c.style.animationDelay = (Math.random() * 0.3) + 's';
      els.confetti.appendChild(c);
    }
    setTimeout(function () { els.confetti.innerHTML = ''; }, 3000);
  }

  build();
})();
